import {CHAPTER_STANDARD_COUNTS, previewChapter} from '@/hooks/sgsst/evaluacion/use-sgsst'

export function chapterNoteFor(
  riskClass: number | null,
  pinnedChapter: number,
  t: (key: string, opts?: Record<string, unknown>) => string
) {
  return (count: number): string | null => {
    if (riskClass === null) return null
    const chapter = previewChapter(count, riskClass)
    return chapter === pinnedChapter
      ? null
      : t('workerCount.chapterChange', {count, chapter, standards: CHAPTER_STANDARD_COUNTS[chapter]})
  }
}
